import React from "react";

const HomeInfo = () => {
  return (
            <section className="homeinfo-section" id="homeinfo">
          <div className="homeinfo-container">
            <p className="homeinfo-topline">Was uns auszeichnet</p>
            <h2 className="homeinfo-title">
              Intelligentes <span className="highlight2">Matching</span> für messbaren Erfolg
            </h2>
            <div className="homeinfo-divider" />
            <p className="homeinfo-subtitle">
              Projekte, Talente und Unternehmen – verbunden durch echte Praxis und klare Ziele.
              <br></br>
              Flexibel, relevant und bereit für neue Perspektiven.
            </p>

            <div className="homeinfo-grid">

        <div className="homeinfo-card talents">
          <img src="/assets/universityicon.png" alt="Talente-Icon" className="homeinfo-icon-img" />
          <h3 className="homeinfo-card-title">Talente</h3>
          <p className="homeinfo-card-text">
            Wir matchen die Aufgaben mit ambitionierten Studierenden aus Top-Universitäten und erfahrenen Senior Experts.
          </p>
        </div>

                            <div className="homeinfo-card projects">
          <img src="/assets/puzzleicon.png" alt="Projekt-Icon" className="homeinfo-icon-img" />
          <h3 className="homeinfo-card-title">Senior Advisors</h3>
          <p className="homeinfo-card-text">
            Erfahrene Senior Advisors unterstützen die Projektteams – von Beginn an oder gezielt in Schlüsselmomenten.
          </p>
        </div>

        <div className="homeinfo-card companies">
          <img src="/assets/charticon.png" alt="Unternehmen-Icon" className="homeinfo-icon-img" />
          <h3 className="homeinfo-card-title">Unternehmen</h3>
          <p className="homeinfo-card-text">
            Unternehmen stellen ihre Ideen oder Herausforderungen vor – innovativ, offen und bereit für effiziente Zusammenarbeit.
          </p>
        </div>
            </div>
      </div>
    </section>
  );
};

export default HomeInfo;
